<template lang="pug">
div
  crud-scroll-details.pa-2(
    ref="list"
    :detailsComponent="detailsComponent"
    :adapter="adapter"
    :queryField="{ label: 'ФИО', key: 'full_name' }"
    :serializeData="serializeData"
  )
    template(#list-header="{ init, unSelect }")
      v-row.mb-4(v-if="!$user.isMentor")
        v-col.pa-0
          v-btn.pr-n5(
            block tile depressed
            :color="tab === 0 ? 'secondary' : ''"
            @click="tab = 0; init(); unSelect();"
          ) Наставники
        v-col.pa-0
          v-btn.pl-n5(
            block tile depressed
            :color="tab === 1 ? 'secondary' : ''"
            @click="tab = 1; init(); unSelect();"
          ) Наставляемые
      .d-flex(
        v-if="tab === 1 && !$user.isMentor"
      )
        v-btn-toggle.mb-4(
          v-model="toggle"
          mandatory
          outlined small
          color="white"
          @change="init"
        )
          v-btn(
            :value="0" :color="toggle === 0 ? 'secondary' : ''"
            small
          ) Заявки
          v-btn(
            :value="1" :color="toggle === 1 ? 'secondary' : ''"
            small
          ) Активные
    template(#list-item="{ item, opencu }")
      v-list-item-content
        v-list-item-title {{ item.user.full_name || item.user.name }}
        v-list-item-subtitle
          v-chip(v-if="!item.is_active && tab === 1" small color="warning") заявка
      v-list-item-action(
        v-if="item.chat"
      )
        v-badge(:value="item.chat.exists_unread_messages" dot overlap color="error")
          v-btn(
            icon color="secondary"
            @click.stop="openChat(item)"
          ): v-icon mdi-chat
    template(#no-select)
      .d-flex(v-if="tab === 0")
        v-btn(color="primary" outlined @click="addMentor").ml-auto Добавить ментора
          v-icon mdi-plus
  portal(to="mentor.dialog" v-slot="{ close, attrs }")
    add-mentor(@success="refreshList")
</template>
<script>
import CrudScrollDetails from '@/components/Global/crudScrollDetails/index.vue';
import MentorDetail from '../components/MentorDetail.vue';
import MentoredDetail from '../components/MentoredDetail.vue';
import AddMentor from '../components/AddMentor.vue';

export default {
  components: {
    AddMentor,
    CrudScrollDetails,
  },
  props: {
  },
  data() {
    return {
      tab: this.$route.query.tab ? +this.$route.query.tab : 1,
      toggle: 1,
    };
  },

  computed: {
    detailsComponent() {
      return {
        component: this.tab === 0 ? MentorDetail : MentoredDetail,
        component_attrs: {},
        component_listeners: {
          selectMentored: (id) => {
            this.tab = Number(!this.tab);
            this.$refs.list.selectById(id, 'user_id');
          },
        },
      };
    },
    method() {
      return this.tab === 0
        ? this.$api.users.getOrganizationUsers : this.$api.mentoring.requestList;
    },
  },
  watch: {
    '$route.query.subTab': {
      handler(val) {
        if (Number.isInteger(+val)) {
          this.tab = 1;
          this.toggle = +val;
          this.refreshList();
        }
      },
      once: true,
    },
    toggle(val) {
      this.$router.replace({ query: { subTab: val } });
    },
    tab(val) {
      this.$router.replace({ query: { tab: val } });
    },
  },
  created() {
    if (Number.isInteger(this.$route.query.subTab)) this.toggle = +this.$route.query.subTab;
  },
  methods: {
    openChat(item) {
      item.chat.open({ title: 'Чат с наставляемым', subtitle: item.user.full_name });
    },
    async serializeData(users) {
      const promises = users.map((i) => {
        if (i.is_active) {
          const params = { expand: 'exists_unread_messages' };
          return this.$api.mentoring.openChat(this.$user.organization.id, i.user_id, params)
            .then(({ item }) => ({ ...i, chat: item }));
        }
        return i;
      });
      const result = await Promise.all(promises);
      return result;
    },
    adapter(params) {
      const { data: user, isMentor, organization } = this.$user;
      const extendParams = {
        expand: 'user,role_name,id,questionnaire_forms,questionnaires,mentor,mentor_recommendations',
        ...this.tab === 0 ? { 'search[role]': 8 } : {
          'search[is_active]': this.toggle,
          'search[mentor_id]': isMentor ? user.id : null,
        },
        ...params,
      };
      return this.method(organization.id, extendParams);
    },
    refreshList() {
      this.$refs.list.unSelect();
      this.$refs.list.refreshList();
    },

    addMentor() {
      this.$modals.show('dialog-portal', {
        dialogProps: {
          width: 800,
        },
        inputValue: 'mentor',
      });
    },
  },
};
</script>
